import Center from '@components/common/alignment/Center';
import React from 'react';

const NoMatch404 = () => {
  return (
    <Center>
      <div>
        <p className='text-5xl font-raleway text-coffee'>404: Not Found.</p>
        <p className='text-2xl font-raleway text-deepspace mt-4'>
          If you clicked a link and ended up here, someone is getting fired.
        </p>
      </div>
    </Center>
  );
};

export default NoMatch404;
